/** @format */

import { cloneDeep } from 'lodash';
export default function(obj: any, deleteKeys = [], mergeObjFun) {
  try {
    let resObj = cloneDeep(obj);
    // console.log('obj and res obj--:', obj, resObj)

    mergeObjFun =
      mergeObjFun ||
      function() {
        return {};
      };
    // for(let i in mergeObj){
    //   if(typeof (mergeObj[i]) ==='function'){
    //     mergeObj[i]=mergeObj[i](resObj)
    //   }
    // }
    resObj = {
      ...resObj,
      ...mergeObjFun(resObj)
    };
    deleteKeys.forEach(key => {
      delete resObj[key];
    });

    return resObj;
  } catch (e) {
    console.warn('e--:', e);
  }
}
